import React, { useCallback, useMemo } from 'react';
import { render } from '.';
import { getLabel } from '../locale';
import { ua } from '../ua';

const Content = (props: any) => {
  const { content, taskId, destroy } = props;
  const btnStyle = useMemo(() => {
    if (ua.device === 'PC') {
      return { color: 'var(--primary)', marginLeft: '8px', cursor: 'pointer' };
    }
  }, []);

  const handleClick = useCallback(() => {
    render(taskId);
    destroy?.()?.();
  }, [destroy, taskId]);
  return (
    <div>
      {content}
      <span style={btnStyle} onClick={handleClick}>
        {getLabel('119011', '查看详情')}
      </span>
    </div>
  );
};

export default Content;
